<div class="p-4 overflow-auto h-[85vh]">
  <div class="flex justify-between -mt-4">
    <h2 class="text-xl font-semibold">Email Configurations</h2>
    <p-button icon="pi pi-plus" label="Add Configuration" (click)="openAddModal()" class="mb-3"></p-button>
  </div>

  <p-table
    [value]="emailConfigs"
    [rows]="rows"
    [totalRecords]="totalRecords"
    [lazy]="true"
    (onLazyLoad)="loadConfigs($event)"
    [loading]="loading"
  >
    <ng-template pTemplate="header">
      <tr>
        <th>Client Name</th>
        <th>Provider</th>
        <th>From Email</th>
        <th>Host</th>
        <th>Port</th>
        <th>Status</th>
        <th>Action</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-config>
      <tr>
        <td>{{ config.clientName }}</td>
        <td>{{ config.provider }}</td>
        <td>{{ config.fromEmail }}</td>
        <td>{{ config.host }}</td>
        <td>{{ config.port }}</td>
        <td>{{ config.status }}</td>
        <td>
          <div (click)="setConfigData(config)">
            <p-menu [tabindex]="undefined" #menu [model]="configActionItem" [popup]="true" appendTo="body"></p-menu>
            <i (click)="menu.toggle($event)" class="pi pi-ellipsis-h action-button cursor-pointer"></i>
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="loading">
      <tr>
        <td colspan="7" class="text-center">
          <p-progressSpinner></p-progressSpinner>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="7" class="no-data">
          <p>No email configurations found</p>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<ng-container *ngIf="displayAddModal">
  <p-dialog [(visible)]="displayAddModal" [modal]="true" [style]="{ width: '50rem' }" [closable]="false">
    <app-create-email-config
      [clientId]="clientId"
      [centers]="centers"
      (reload)="reload()"
      (close)="closeAddModal()"
    ></app-create-email-config>
  </p-dialog>
</ng-container>

<ng-container *ngIf="showEditConfig">
  <p-dialog [(visible)]="showEditConfig" [modal]="true" [style]="{ width: '50rem' }" [closable]="false">
    <app-create-email-config
      [clientId]="clientId"
      [centers]="centers"
      [type]="'Update'"
      [emailConfigDataToEdit]="configDataToEdit"
      (reload)="reload()"
      (close)="showEditConfig = false"
    ></app-create-email-config>
  </p-dialog>
</ng-container>

<ng-container *ngIf="showDeleteConfig">
  <p-dialog [(visible)]="showDeleteConfig" [modal]="true" [style]="{ width: '40rem' }" [closable]="false">
    <app-delete-email-config
      [clientId]="clientId"
      [emailConfigDataToEdit]="configDataToEdit"
      (reload)="reload()"
      (close)="showDeleteConfig = false"
    ></app-delete-email-config>
  </p-dialog>
</ng-container>
